import {
    GET_MASTER_DATA, LOADING_DATA, SHOW_SNACKBAR, GET_NOTIFICATIONS, CALL_LOAD_MORE_DATA,
    GET_VAULT_DATA, UPDATE_VAULT_DATA, GET_CURRENT_ROUTE, SET_MULTI_SELECT_LIST, GET_MULTI_SELECT_DATA, GET_OCCUPATIONS,
    GET_VERTICAL_LIST, GET_PRODUCT_LIST, GET_IMD_RELATION_LIST, GET_CHANNEL_ZONE_LIST, ADD_VAULT_DATA, GET_BIRTHDAY_LIST, SET_MAP_INFO
} from '../types/CommonType';

const initState = {
    masterData: [], isLoading: false, loadMoreData: false, showSnack: false, snackMsg: '', selectedMapInfo:null,
    notifications: [], vaultData: [], currentRoute: {}, multiSelectList: [], multiSelectData: [], occupationList: [], verticalList: [], birthdayList: []
};

const CommonReducer = (state = initState, action) => {
    switch (action.type) {
        case GET_MASTER_DATA:
            return {
                ...state,
                masterData: !action.error ? action.payload : state.masterData
            }
        case GET_NOTIFICATIONS:
            return {
                ...state,
                notifications: !action.error ? action.payload.list : state.notifications
            }
        case GET_VAULT_DATA:
            return {
                ...state,
                vaultData: !action.error ? action.payload.list : state.vaultData
            }
        case ADD_VAULT_DATA: {
            return {
                ...state,
                vaultData: [...state.vaultData, action.payload]
            }
        }
        case LOADING_DATA:
            return {
                ...state,
                isLoading: action.payload
            }
        case CALL_LOAD_MORE_DATA:
            return {
                ...state,
                loadMoreData: action.payload
            }
        case SHOW_SNACKBAR:
            return {
                ...state,
                showSnack: action.payload.status,
                snackMsg: action.payload.msg
            }
        case GET_CURRENT_ROUTE:
            return {
                ...state,
                currentRoute: action.payload
            }
        case SET_MULTI_SELECT_LIST:
            return {
                ...state,
                multiSelectList: action.payload
            }
        case GET_MULTI_SELECT_DATA:
            return {
                ...state,
                multiSelectData: action.payload.status ? [...state.multiSelectData, action.payload.data] : state.multiSelectData.filter(obj => obj !== action.payload.data)
            }
        case GET_OCCUPATIONS:
            return {
                ...state,
                occupationList: action.payload
            }
        case GET_VERTICAL_LIST:
            return {
                ...state,
                verticalList: action.payload
            }
        case UPDATE_VAULT_DATA:
            let updatedData = !action.error ? state.vaultData.find(obj => obj.id === action.payload.id) : state.vaultData
            let indexVal = !action.error ? state.vaultData.findIndex(obj => obj.id === action.payload.id) : 0
            updatedData = !action.error ? { ...updatedData, 'status': action.payload.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE' } : state.vaultData

            return {
                ...state,
                vaultData: !action.error ? [...state.vaultData.slice(0, indexVal), updatedData, ...state.vaultData.slice(indexVal + 1)] : state.vaultData
            }
        case GET_PRODUCT_LIST:
            return {
                ...state,
                productList: action.payload
            }
        case GET_IMD_RELATION_LIST:
            return {
                ...state,
                imdRelationshipList: action.payload
            }
        case GET_CHANNEL_ZONE_LIST:
            return {
                ...state,
                channelZoneList: action.payload
            }
        case GET_BIRTHDAY_LIST:
            return {
                ...state,
                birthdayList: action.payload.list
            }
        case SET_MAP_INFO:
            return {
                ...state,
                selectedMapInfo:action.payload 
            }

        default:
            return state;
    }
}

export default CommonReducer